import TextFieldValidate from "./TextFieldValidate"
import { useEffect } from "react"
import { useState } from "react"
import { useMyInput } from "../ValidateForm"

// forciblyValue = принудиьельное значение в любой момент
const TextFieldUniversal = ({ // Основное поле для проверки данных
    value, forciblyValue, setValue, label, placeholder, forciblyError, setValidate, disabled,
    required = false, validates = {}, onBlurMy, classNameAdd, ...rest
}) => {

    const [validatesTemp, setValidatesTemp] = useState(validates)

    const fieldValidate = useMyInput('', validatesTemp)

    // console.log('fieldValidate', fieldValidate)

    // якщо required змінюється — додаємо/знімаємо правило isEmpty
    useEffect(() => {
        // console.log('required !!', required)
        if (required) {
            setValidatesTemp({ ...validates, isEmpty: true })
        } else {
            // console.log('validates !!', validates)
            setValidatesTemp(validates)
            // setValidatesTemp({ ...validates, isEmpty: false })
        }
    }, [required, validates])

    // визначаємо значення для відображення (пріоритет: forciblyValue > value)
    const displayValue = forciblyValue ?? value ?? ''

    // оновлюємо валідатор тільки якщо displayValue змінився
    useEffect(() => {
        if (displayValue !== fieldValidate.value) {
            fieldValidate.onChange(displayValue)
            fieldValidate.onBlur()
        }
    }, [displayValue])

  return (
    <TextFieldValidate
        className={ classNameAdd ? `${classNameAdd} myTextField` : 'myTextField' }
        // field={fieldValidate}
        field={{
            ...fieldValidate,
            value: displayValue, // 👈 керуємо value тільки з пропсів
            onChange: (val) => {
                setValue && setValue(val) // міняємо наверху
                fieldValidate.onChange(val) // валідатор бачить зміни
            }
        }}
        label={label} 
        placeholder={placeholder}
        forciblyError={forciblyError}
        onBlurMy={onBlurMy}
        setValidate={setValidate}
        required={required}
        disabled={disabled}
        {...rest}
    />
  )
}

export default TextFieldUniversal